<div *ngIf="!isWizard">
  <div class="sub-header">{{'onboarding.update_vend_config' | translate}}</div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_register' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_register_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-shopping-basket"></i></span>
        <p-dropdown [options]="registers" [(ngModel)]="config.RegisterID"
                    placeholder="{{'onboarding.select_register' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_tax' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_tax_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-money"></i></span>
        <p-dropdown [options]="taxes" [(ngModel)]="config.TaxID"
                    placeholder="{{'onboarding.select_tax' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_user' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_user_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-user"></i></span>
        <p-dropdown [options]="users" [(ngModel)]="config.UserID"
                    placeholder="{{'onboarding.select_user' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_payment_type' | translate}}:
      <span class="help fa hubtiger-tooltip"
            pTooltip="{{'onboarding.select_payment_type_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="paymentTypes" [(ngModel)]="config.PaymentTypeID"
                    placeholder="{{'onboarding.select_payment_type' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-8 label"></div>
    <div class="col-md-4">
      <button type="submit" class="iso-round-button" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.RegisterID || !config.UserID || !config.TaxID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.RegisterID && config.UserID && config.TaxID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>

  <div *ngIf="technicians && technicians.length > 0 && isWorkshop">
    <div class="sub-header margin-top-16">
      {{ "bikeshop.shop_profile.pos-integration.technichan_linking" | translate }}
    </div>
    <div><small>{{ "bikeshop.shop_profile.pos-integration.technichan_linking_info" | translate }}</small></div>
    <div *ngFor="let technician of technicians" class="row margin-top-8">
      <div class="col-md-4 label">
        {{technician.Firstname}} {{technician.Surname}}
      </div>
      <div class="col-md-8">
        <p-dropdown [options]="users" [(ngModel)]="technician.POSEmployeeID" [showClear]="true"
                    placeholder="{{ 'bikeshop.shop_profile.pos-integration.link_technician_to_pos_employee' | translate }}">
        </p-dropdown>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-8 label"></div>
      <div class="col-md-4">
        <button type="submit" class="iso-round-button secondary full-width" style="float: right;"
                (click)="updateTechnicians()"
                [disabled]="busyTechnicians">{{ busy ? ('onboarding.button.please_wait' | translate) : ('bikeshop.shop_profile.pos-integration.updated_linked_technicians' | translate) }}</button>
      </div>
    </div>
  </div>

</div>

<!--Bit of a stuff up because of the dark UI in the wizard and light wizard in the portal, this is a shared compnent :(-->
<div *ngIf="isWizard">
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="registers" [(ngModel)]="config.RegisterID"
                    placeholder="{{'onboarding.select_register' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_register' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_register_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="taxes" [(ngModel)]="config.TaxID"
                    placeholder="{{'onboarding.select_tax' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_tax' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_tax_info' | translate}}"></span>
  </div>
  <div class="row margin-top-32 help-row">
    <div class="col-md-12">
      <div class="p-float-label">
        <p-dropdown [options]="users" [(ngModel)]="config.UserID"
                    placeholder="{{'onboarding.select_user' | translate}}">
        </p-dropdown>
        <label>{{'onboarding.select_user' | translate}}</label>
      </div>
    </div>
    <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_user_info' | translate}}"></span>
  </div>

  <div class="row margin-top-32">
    <div class="col-md-12">
      <button type="submit" class="iso-round-button secondary full-width" style="float: right;"
              (click)="updateConfig()"
              [disabled]="busy || !config.RegisterID || !config.UserID || !config.TaxID">{{ busy ? ('onboarding.button.please_wait' | translate) : (config.RegisterID && config.UserID && config.TaxID) ? ('onboarding.button.update_config' | translate) : ('onboarding.button.set_config' | translate)}}</button>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
